import { Injectable } from '@angular/core';

import { DataEntry } from '@osos/shared/api';
import { TimelineCategoryPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable({
  providedIn: 'root',
})
export class TimelineCategoryV1ParserService extends ParserBase<
  DataEntry,
  TimelineCategoryPresenterModel
> {
  constructor() {
    super(DataEntry, TimelineCategoryPresenterModel, 1);
  }
  getPresenterModel(model: Partial<DataEntry>): TimelineCategoryPresenterModel {
    return {
      id: model.id,
      title: model.value?.title,
      attributes: model.value?.attributes,
      specificationVersion: model.specificationVersion,
    };
  }
  getDataModel(presenter: TimelineCategoryPresenterModel): DataEntry {
    throw new Error('Method not implemented.');
  }
}
